export default __webpack_public_path__ + "static/media/partners20.0a3b8b4d.png";